export const getImageDimensions = (
  dataUrl: string
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      if (img.naturalWidth > 7500 || img.naturalHeight > 7500) {
        reject(
          new Error('Image dimensions exceed maximum allowed size of 7500px.')
        )
      } else {
        resolve({ width: img.naturalWidth, height: img.naturalHeight })
      }
    }
    img.onerror = (err) => {
      console.error('Failed to load image for dimension check:', err)
      reject(new Error('Failed to load image to check dimensions.'))
    }
    img.src = dataUrl
  })
}

export const getVideoDimensions = (
  file: File
): Promise<{ width: number; height: number; length: number }> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = URL.createObjectURL(file);
    video.load();
    video.addEventListener('loadedmetadata', () => {
      resolve({ width: video.videoWidth, height: video.videoHeight, length: video.duration });
    });
    video.onerror = (err) => {
      console.error('Failed to load video for dimension check:', err)
      reject(new Error('Failed to load video.'))
    }
  })
}